export default __webpack_public_path__ + "static/media/chinese-food.cb0c593a.png";